/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import isObject from 'lodash/isObject';

/**
 * Detektor volného místa na disku
 */
class FileSystemSpaceDetector {
  /**
   * Vytvoří instanci.
   * @param {LogicalUnitMapper} logicalUnitMapper
   * @returns {FileSystemSpaceDetector} Nová instance.
   */
  constructor(logicalUnitMapper) {
    if (!isObject(logicalUnitMapper)) {
      throw new TypeError('Invalid LogicalUnitMapper.');
    }

    this.logicalUnitMapper = logicalUnitMapper;
  }

  /**
   * Detekuje, jestli je na disku dostatek volného místa.
   * @param {LogicalUnit} logicalUnit Logicka jednotka.
   * @param {Byte} size Velikost požadovaného místa.
   * @returns {Promise.<boolean>} Příznak, jestli je dostatek volného místa.
   */
  async detect(logicalUnit, size) {
    if (!isObject(logicalUnit)) {
      throw new TypeError('Invalid unit.');
    }
    if (!Number.isFinite(size)) {
      throw new TypeError(`Invalid size ${size}.`);
    }
    const fileSystemUnit = await this.logicalUnitMapper.toFileSystemUnit(
      logicalUnit
    );
    // Porovnání volného místa s požadovaným.
    const { free } = await fileSystemUnit.getInfo();
    return free >= size;
  }
}

export default FileSystemSpaceDetector;
